<template>
  <div class="bcc-checkbox-group" role="group">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'BccCheckboxGroup',
  componentName: 'BccCheckboxGroup',
  props: {
    value: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
